import {
  ListContextProvider,
  ResourceContextProvider,
  useList,
  useTranslate,
} from "ra-core";
import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

import { TasksIterator } from "./TasksIterator";

type TaskListProps = {
  tasks: any[];
  title: string;
  showContact?: boolean;
  isMobile: boolean;
  /** Accordion section: header toggles, count always visible. */
  collapsible?: boolean;
  defaultOpen?: boolean;
};

export const TaskListFilter = ({
  tasks,
  title,
  showContact,
  isMobile,
  collapsible = false,
  defaultOpen = true,
}: TaskListProps) => {
  const translate = useTranslate();
  const [open, setOpen] = useState(defaultOpen);
  const listContext = useList({
    data: tasks,
    resource: "tasks",
    perPage: isMobile ? 10 : 5,
  });

  const { total } = listContext;

  if (!tasks?.length || !total) return null;

  const header = collapsible ? (
    <button
      type="button"
      onClick={() => setOpen((v) => !v)}
      className="flex items-center gap-1.5 text-xs uppercase tracking-wider text-muted-foreground font-medium hover:text-foreground transition-colors w-full text-left"
    >
      {open ? (
        <ChevronDown className="w-3.5 h-3.5" />
      ) : (
        <ChevronRight className="w-3.5 h-3.5" />
      )}
      {title}
      <span className="ml-auto tabular-nums rounded-full bg-muted px-1.5 py-0.5 text-[10px] normal-case">
        {total}
      </span>
    </button>
  ) : (
    <p className="text-xs uppercase tracking-wider text-muted-foreground font-medium mb-2">
      {title}
    </p>
  );

  return (
    <div className="flex flex-col gap-2">
      {header}
      {(!collapsible || open) && (
        <>
          <ResourceContextProvider value="tasks">
            <ListContextProvider value={listContext}>
              <TasksIterator showContact={showContact} />
            </ListContextProvider>
          </ResourceContextProvider>
          {total > listContext.perPage && (
            <div className="flex justify-center">
              <a
                href="#"
                onClick={(e) => {
                  listContext.setPerPage(listContext.perPage + 10);
                  e.preventDefault();
                }}
                className="text-sm underline hover:no-underline"
              >
                {translate("crm.common.load_more")}
              </a>
            </div>
          )}
        </>
      )}
    </div>
  );
};
